import { z } from 'zod'

// Files travel from the browser in chunks of this size, so the server never
// holds more than one chunk in memory — no overall file-size limit needed
export const UPLOAD_CHUNK_BYTES = 8 * 1024 * 1024

const mediaKeySchema = z
  .string()
  .regex(/^notes-media\/[^/]+$/, 'must be a note media key')

export const startMediaUploadSchema = z.object({
  fileName: z.string().min(1),
  contentType: z
    .string()
    .refine((ct) => ct.startsWith('image/') || ct.startsWith('video/'), {
      message: 'Only image and video files can be uploaded',
    }),
})

export const uploadMediaPartSchema = z.object({
  key: mediaKeySchema,
  uploadId: z.string().min(1),
  partNumber: z.number().int().min(1).max(10000),
  dataBase64: z.string().min(1),
})

export const finishMediaUploadSchema = z.object({
  key: mediaKeySchema,
  uploadId: z.string().min(1),
  parts: z
    .array(z.object({ partNumber: z.number().int().min(1), etag: z.string().min(1) }))
    .min(1),
})

export const abortMediaUploadSchema = z.object({
  key: mediaKeySchema,
  uploadId: z.string().min(1),
})

export const getMediaUrlsSchema = z.object({
  keys: z.array(z.string().min(1)).max(200),
})

// Thumbnails are small JPEGs captured client-side from the video's first frame
export const uploadNoteMediaThumbSchema = z.object({
  forKey: z
    .string()
    .regex(/^notes-media\/[^/]+$/, 'must be an existing note media key'),
  dataBase64: z.string().min(1),
})

export interface UploadedMedia {
  key: string
  url: string
  kind: 'image' | 'video'
}
